<app-navigation tagline="IMPRESSUM" marginLeftClass="ml-10"></app-navigation>
<ion-content>
  <div class="ion-margin slide imprint white">
  <h1>Impressum</h1>
  <h4>Herausgeber</h4>
  <p>Ministerium für Wirtschaft, Arbeit und Tourismus Baden-Württemberg<br>
    Schlossplatz 4 (Neues Schloss)<br>
    70173 Stuttgart<br>
    Tel.0711 123-0<br>
    E-Mail: <a href="mailto:poststelle@wm.bwl.de">poststelle&#64;wm.bwl.de</a>
  </p>
  <h4>Verantwortlich </h4>
  <p>
    Tanja Wacker<br>
    E-Mail: <a href="mailto:orientando@wm.bwl.de">orientando&#64;wm.bwl.de </a>
  </p>
  <h4>Kooperationspartner </h4>
 <p>  MTO Psychologische Forschung und Beratung GmbH<br>
  Schleifmühleweg 68<br>
  72070 Tübingen<br>
  Internet: <a target="_blank" href="https://www.mto.de/bildung">https://www.mto.de/bildung</a><br>
</p>
<h4>Technische Realisierung und Betreuung</h4>
<p>
artif GmbH & Co. KG<br>
Alexanderstraße 65<br>
72072 Tübingen<br>
Internet: <a target="_blank" href="https://artif.com">https://artif.com</a><br>
</p>
<h4>Haftungsausschluss</h4>
<p>
  Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir <b>keine Haftung</b> für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
  </p>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
